// formats a number to be a more human-readable string
// 100000000 -> 100 000 000. or
// 1000000 -> 1 000 000.
export function numberWithSpaces(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
